import axios from '@/api/http'; // 导入http中创建的axios实例
import { getFormatDateTime } from '@/views/ipp/ipp-view-detail/components/RoiBrowser/utils.js';
export const BASE = process.env.NODE_ENV === 'development' ? 'zky/api' : localStorage.getItem('ipp_ip') ? localStorage.getItem('ipp_ip') + '/api' : 'api';
import dayjs from 'dayjs';

const lang = localStorage.getItem('ipp_lang') || 'zh';
const index = {
  // 用户登录
  user_login(data) {
    return axios.post(`${BASE}/wyrbac/login/login`, data);
  },

  // 退出登录
  user_logout(data) {
    return axios.post(`${BASE}/wyrbac/login/logout`, data);
  },

  // 获取用户信息
  user_info() {
    return axios.get(`${BASE}/wyrbac/login/user-info`);
  },
  // 获取配置信息
  get_config_info() {
    return axios.get(`${BASE}/get-lang/lang`, { params: { limit: 500, language: lang } });
  },
  site_ipp_one(data) {
    return axios.post(`${BASE}/site/ipp-one`, data);
  },
  // 获取角色
  setting_get_role() {
    return axios.get(`${BASE}/setting/get-role?language=` + lang);
  },
  // 用户系统信息
  tool_sys_init(params) {
    return axios.get(`${BASE}/tool/sys-init?language=${lang}&sort=-title`, { params });
  },

  // 获取系统配置
  setting_get_set_init(params) {
    return axios.get(`${BASE}/setting/get-set-init`, { params });
  },

  // 保存系统配置
  setting_save_console(data) {
    return axios.post(`${BASE}/setting/save-console`, data);
  },

  // 获取我的设备
  ipp_index(params) {
    return axios.get(`${BASE}/ipp/index?limit=100`, { params });
  },
  // 获取我的设备
  get_ipp_list(params) {
    return axios.get(`${BASE}/ipp/index`, { params });
  },

  // 删除设备
  ipp_delete(data) {
    return axios.post(`${BASE}/ipp/delete`, data);
  },

  // 以图搜图
  python_feature(data) {
    return axios.post(`${BASE}/python/feature`, data);
  },

  user_index(params) {
    return axios.get(`${BASE}/user/index`, { params });
  },

  // 团队列表
  group_index(params) {
    return axios.get(`${BASE}/group/index`, { params });
  },
  // 添加团队
  group_save(data) {
    return axios.post(`${BASE}/group/save`, data);
  },
  // 删除团队
  group_delete(id) {
    return axios.post(`${BASE}/group/delete`, { ids: [id] });
  },

  // 添加用户
  setting_save_user(data) {
    return axios.post(`${BASE}/setting/save-user`, data);
  },
  // 获取设备信息
  setting_index(params) {
    return axios.get(`${BASE}/setting/index`, { params });
  },
  // 获取设备信息
  setting_index2(params) {
    return axios.get(`${BASE}/spi-info/index`, { params });
  },

  // 保存设备信息
  setting_save(data) {
    return axios.post(`${BASE}/setting/save`, data);
  },
  // 操作图片
  roi_save_move(data, { category_id, target_id, type, ipp_id, hi, change_roi_labelindex, folder_code }) {
    if (change_roi_labelindex === 0) change_roi_labelindex = 0;
    else change_roi_labelindex = 1;

    if (target_id === -4) {
      change_roi_labelindex = folder_code;
      if (category_id === -5) {
        hi = 1;
      }
    }

    if ([-2, -3].includes(target_id)) {
      change_roi_labelindex = 0;
    }

    if (target_id) {
      if (hi === 0 || hi === 1) {
        if (target_id === -4 && category_id === -5) {
          return axios.post(
            `${BASE}/roi/save-move?ipp_id=${ipp_id}&category_id=${category_id}&target_id=${target_id}&type=${type}&hi=${hi}&change_roi_labelindex=${change_roi_labelindex}&change_status=null`,
            data
          );
        } else {
          return axios.post(
            `${BASE}/roi/save-move?ipp_id=${ipp_id}&category_id=${category_id}&target_id=${target_id}&type=${type}&hi=${hi}&change_roi_labelindex=${change_roi_labelindex}`,
            data
          );
        }
      } else {
        return axios.post(
          `${BASE}/roi/save-move?ipp_id=${ipp_id}&category_id=${category_id}&target_id=${target_id}&type=${type}&change_roi_labelindex=${change_roi_labelindex}`,
          data
        );
      }
    } else {
      return axios.post(`${BASE}/roi/save-move?ipp_id=${ipp_id}&category_id=${category_id}&type=${type}&change_roi_labelindex=${change_roi_labelindex}`, data);
    }
  },

  views_roi30(params) {
    return axios.get(`${BASE}/views/roi30`, { params });
  },

  views_roi24(params) {
    return axios.get(`${BASE}/views/roi24`, { params });
  },
  // 取设备最后数据上报时间
  dashboard_get_last_insert_time(params) {
    return axios.get(`${BASE}/dashboard/get-last-insert-time`, { params });
  },
  roi_index_index(params) {
    return axios.get(`${BASE}/roi-index/index`, { params });
  },
  // 获取图片详情
  get_roi_detail(params) {
    return axios.get(`${BASE}/roi/index`, { params });
  },
  // 【临时分类、分类】新建
  roi_add_folder(data) {
    let { ipp_id, category_id } = data;
    if (category_id === -6) {
      ipp_id = -6;
      data.ipp_id = -6;
    }
    return axios.post(`${BASE}/roi-index/save?ipp_id=${ipp_id}`, data);
  },
  // 修改分类状态
  roi_change_folder(data) {
    return axios.post(`${BASE}/roi-index/save`, data);
  },
  // 【临时分类】删除
  roi_delete_tool_bar_folder(data, { ipp_id, id }) {
    return axios.post(`${BASE}/roi-index/delete-tool-bar?ipp_id=${ipp_id}&id=${id}`, data);
  },
  // 【临时分类】获取
  roi_get_tool_bar_folder(params) {
    return axios.get(`${BASE}/roi-index/tool-bar`, { params });
  },

  // 集萃墙
  views_wall(params) {
    return axios.get(`${BASE}/views/wall`, { params });
  },

  // 修改密码
  account_change_pass_wd({ password, newpassword }) {
    return axios.post(`${BASE}/account/change-pass-wd`, { password, newpassword });
  },

  // 用户列表(O)
  user_index(params) {
    return axios.get(`${BASE}/user/index`, { params });
  },
  // 新增用户(O)
  user_save(data) {
    return axios.post(`${BASE}/user/save`, data);
  },
  // 删除用户(O)
  user_delete(data) {
    return axios.post(`${BASE}/user/delete`, data);
  },

  // 【roi】获取文件夹
  get_roi_folder(params) {
    const ipp_role = localStorage.getItem('ipp_role');
    const { RoiBrowserForm, EChartsPieForm, EChartsBarForm } = JSON.parse(localStorage.getItem('ipp_view_detail_form'));
    const ipp_id = params.ipp_id || localStorage.getItem('ipp_view_detail_ipp_id');
    let group_id = '';
    if (ipp_role === 'superadmin') {
      // 如果是超级管理员，需要从所有站位里面寻找站位对应的团队
      const ippList = JSON.parse(localStorage.getItem('ipp_list'));
      group_id = ippList.find(x => x.id == ipp_id).group_id;
    } else if (ipp_role === 'administrator') {
      const userInfo = JSON.parse(localStorage.getItem('ipp_user_config'));
      group_id = userInfo.group_id;
    } else if (ipp_role === 'user') {
      const userInfo = JSON.parse(localStorage.getItem('ipp_user_config'));
      group_id = userInfo.group_id;
    }

    params = { ...params, dataIndex: '', code: '', from: 'echart_category', limit: 1000, page: 1, language: lang };

    // 和日期无关
    if ([-1, -2, -3, -6, -7].includes(params.category_id)) {
      params.Roi_time_s = '';
      params.Roi_time_e = '';
      params.coordRange_0 = '';
      params.coordRange_1 = '';
      params.dataIndex = '';
    }

    // 机器识别
    if (params.category_id === -5) params.table = 'roi';
    // 团队相关
    if (params.category_id === -2) params.group_id = group_id;
    // Xcube参考库
    else if (params.category_id === -1) params.group_id = null;
    // 站位相关
    else params.ipp_id = ipp_id;

    // 非 站位参考库
    if (params.category_id !== -7) {
      delete params.reviewed_type;
    }

    // 默认排序
    if (!params.sorttype) params.sorttype = 'asc';
    if (!params.diysort) params.diysort = 'Roi_time';

    const { Roi_time_s, Roi_time_e } = getFormatDateTime(EChartsBarForm);
    params = {
      ...params,
      Roi_time_s,
      Roi_time_e
    };
    delete params.coordRange_0;
    delete params.coordRange_1;

    return axios.get(`${BASE}/folder/get-folder-by-roi-index`, { params });
  },

  get_roi_folder_by_roi_index(params) {
    return axios.get(`${BASE}/folder/get-folder-by-roi-index`, { params });
  },

  // 【roi】获取文件夹下面的图片
  get_roi_file(params) {
    const ipp_role = localStorage.getItem('ipp_role');

    params = { ...params, code: '', from: 'echart_category', language: lang };

    if (ipp_role !== 'superadmin' && params.category_id === -1) {
      params.category_id = -6;
    }

    // 和日期无关
    if ([-1, -2, -3, -6, -7].includes(params.category_id)) {
      params.Roi_time_s = '';
      params.Roi_time_e = '';
      params.coordRange_0 = '';
      params.coordRange_1 = '';
    }
    // 机器识别
    if (params.category_id === -5) params.table = 'roi';

    const { EChartsBarForm } = JSON.parse(localStorage.getItem('ipp_view_detail_form'));
    const { Roi_time_s, Roi_time_e } = getFormatDateTime(EChartsBarForm);
    params = {
      ...params,
      Roi_time_s,
      Roi_time_e
    };
    delete params.coordRange_0;
    delete params.coordRange_1;

    // 设置默认值
    if (!params.limit) params.limit = 200;
    if (!params.page) params.page = 1;
    if (!params.sorttype) params.sorttype = 'desc';
    if (!params.diysort) params.diysort = 'Roi_time';

    if (params.category_id === -7) {
      delete params.Roi_time_s;
      delete params.Roi_time_e;
      delete params.coordRange_0;
      delete params.coordRange_1;
      delete params.dataIndex;
      delete params.code;
      delete params.from;
      const ipp_id = localStorage.getItem('ipp_view_detail_ipp_id');
      const { loc } = JSON.parse(localStorage.getItem('ipp_user_config'));
      const { dev_id } = loc.find(x => x.id == ipp_id);
      params.dev_id = dev_id;

      return axios.get(`${BASE}/roi/get-site-roi`, { params });
    }

    return axios.get(`${BASE}/roi/get-roi-by-code`, { params });
  },
  // 【roi】复制、移动文件夹
  move_roi_folder(params) {
    return axios.get(`${BASE}/roi/get-roi-by-code`, { params });
  },
  // 【roi】获取全部图片
  get_roi_all_file(params) {
    params = { ...params, code: '', from: 'echart_category', language: lang };

    const { EChartsBarForm } = JSON.parse(localStorage.getItem('ipp_view_detail_form'));
    const { Roi_time_s, Roi_time_e } = getFormatDateTime(EChartsBarForm);
    params = {
      ...params,
      Roi_time_s,
      Roi_time_e
    };
    delete params.coordRange_0;
    delete params.coordRange_1;

    const { category_id, id } = params;
    if (category_id === -1000) {
      // 回收站
      params.dev_id = id;
      // delete params.category_id;
    }
    return axios.get(`${BASE}/roi/all`, { params });
  },

  // 【回收站】还原(re)
  roi_group_re_bin_restore(data) {
    return axios.post(`${BASE}/roi-group/re-bin?action=re`, data);
  },
  // 【回收站】清空(delete)
  roi_group_re_bin_clear(data) {
    const ipp_id = localStorage.getItem('ipp_view_detail_ipp_id');
    return axios.post(`${BASE}/roi-group/re-bin?action=delete&ipp_id=${ipp_id}&type=all`, data);
  },
  // 【回收站】删除(delete)
  roi_group_re_bin_delete(data) {
    const ipp_id = localStorage.getItem('ipp_view_detail_ipp_id');
    return axios.post(`${BASE}/roi-group/re-bin?action=delete&ipp_id=${ipp_id}&type=`, data);
  },

  // 删除roi
  roi_delete(data) {
    return axios.post(`${BASE}/roi/delete`, data);
  },
  // 删除roi文件夹
  roi_delete_folder(id) {
    return axios.post(`${BASE}/roi/delete?roi_index_id=${id}`);
  },

  // 【回收站】添加图片
  roi_group_delete(data, category_id) {
    return axios.post(`${BASE}/roi-group/delete?category_id=${category_id}`, data);
  },
  // 【回收站】添加分类
  roi_index_batch_delete(data, ipp_id) {
    return axios.post(`${BASE}/roi-index/batch-delete?ipp_id=${ipp_id}`, data);
  },

  // 删除临时分类
  delete_temporary_folder(roi_index_id) {
    return axios.post(`${BASE}/folder/delete-temporary-folder?roi_index_id=${roi_index_id}`);
  },

  // 【回收站】添加分类
  roi_index_delete_folder({ ipp_id, index_id, group_id, category_id }) {
    return axios.post(`${BASE}/roi-index/delete-folder?ipp_id=${ipp_id}&index_id=${index_id}&group_id=${group_id}&category_id=${category_id}`);
  },

  // 获取设备图片
  views_rois(params) {
    return axios.get(`${BASE}/views/rois`, { params });
  },

  // 设置所有团队的某个分类status字段内容
  roi_index_change_status(data) {
    return axios.post(`${BASE}/roi-index/change-status`, data);
  },
  // 设置所有团队的某个分类
  roi_index_rsync(data) {
    return axios.post(`${BASE}/roi-index/rsync`, data);
  },
  // 获取Xcube参考库的示例图片
  roi_categorys_demo(params) {
    return axios.get(`${BASE}/roi/categorys`, { params });
  },

  // 上传图片
  upload_image(data, action = '') {
    return axios.post(`${BASE}/upload/index?action=${action || lang}`, data);
  },

  // 添加示例图片
  proxy_roi_xcube_uploads(data) {
    return axios.post(`${process.env.NODE_ENV === 'development' ? 'api/' : ''}uploads`, data);
  },
  // 添加关注文件夹
  proxy_add_collect_folders(data) {
    return axios.post(`${process.env.NODE_ENV === 'development' ? 'api/' : ''}folders/add`, data);
  },
  // 删除关注文件夹
  proxy_delete_collect_folders(data) {
    return axios.post(`${process.env.NODE_ENV === 'development' ? 'api/' : ''}folders/delete`, data);
  },
  // 查询关注文件夹
  proxy_query_collect_folders(data) {
    return axios.post(`${process.env.NODE_ENV === 'development' ? 'api/' : ''}folders/query`, data);
  },
  get_roi_details(roi_id) {
    return axios.get(`${BASE}/roi/get-roi-details?roi_id=${roi_id}`);
  },
  // 重识别
  set_roi_label_index(params) {
    return axios.get(`${BASE}/roi/set-roi-label-index`, {
      params
    });
  },

  setting_get_group_view(group_id) {
    return axios.get(`${BASE}/setting/get-group-view?group_id=${group_id}`);
  },
  setting_set_group_view(data) {
    return axios.post(`${BASE}/setting/set-group-view`, data);
  },

  // 类别重命名
  roi_folder_rename({ roi_index_id, title }) {
    return axios.post(`${BASE}/roi-index/rename?roi_index_id=${roi_index_id}&title=${title}`);
  },
  // 查询上一张、下一张
  roi_get_adjacent_roi({ roi_id, type }) {
    const { RoiBrowserForm, EChartsPieForm, EChartsBarForm } = JSON.parse(localStorage.getItem('ipp_view_detail_form'));
    const ipp_id = localStorage.getItem('ipp_view_detail_ipp_id');
    const { loc } = JSON.parse(localStorage.getItem('ipp_user_config'));
    const { Roi_time_s, Roi_time_e } = getFormatDateTime(EChartsBarForm);

    const { category_id, roi_index_code, roi_index_id, sorttype, diysort } = RoiBrowserForm;

    const { dev_id } = loc.find(x => x.id == ipp_id);

    let params = {
      Roi_time_e,
      Roi_time_s,
      category_id,
      roi_index_code,
      roi_index_id,
      sorttype,
      diysort,
      dev_id,
      roi_id,
      type
    };

    if (category_id === -100) {
      params.params = '/roi/all';
    } else {
      params.params = '/roi/get-roi-by-code';
    }

    return axios.get(`${BASE}/roi/get-adjacent-roi`, { params });
  },

  // 【站位参考库】品类  移除、批准、拒绝、增加
  folder_roperator_site_folder({ category_id, type, roi_index_code, Roi_time_s, Roi_time_e }) {
    const ipp_id = localStorage.getItem('ipp_view_detail_ipp_id');
    const { loc } = JSON.parse(localStorage.getItem('ipp_user_config'));
    const { dev_id } = loc.find(x => x.id == ipp_id);

    return axios.post(
      `${BASE}/folder/operator-site-folder?dev_id=${dev_id}&category_id=${category_id}&type=${type}&roi_index_code=${roi_index_code}&Roi_time_s=${Roi_time_s}&Roi_time_e=${Roi_time_e}`
    );
  },

  // 【站位参考库】ROI  移除、批准、拒绝、增加
  roi_operator_site_roi({ category_id, type }, data) {
    const ipp_id = localStorage.getItem('ipp_view_detail_ipp_id');
    const { loc } = JSON.parse(localStorage.getItem('ipp_user_config'));
    const { dev_id } = loc.find(x => x.id == ipp_id);

    return axios.post(`${BASE}/roi/operator-site-roi?dev_id=${dev_id}&category_id=${category_id}&type=${type}`, data);
  },

  // 【站位参考库-ROI】复制到Xcube库，Xcube库 ROI 移除
  roi_operator_roi({ dev_id, category_id, target_category_id, type, roi_index_code, roi_index_code_target }, data) {
    if (type === 'remove') {
      if ([-1, -2].includes(category_id)) {
        // 团队参考库、Xcube 参考库
        return axios.post(`${BASE}/roi/operate-roi?category_id=${category_id}&type=${type}&roi_index_code=${roi_index_code}`, data);
      }
      return axios.post(`${BASE}/roi/operate-roi?dev_id=${dev_id}&category_id=${category_id}&type=${type}&roi_index_code=${roi_index_code}`, data);
    }
    return axios.post(
      `${BASE}/roi/operate-roi?dev_id=${dev_id}&category_id=${category_id}&type=${type}&roi_index_code=${roi_index_code}&roi_index_code_target=${roi_index_code_target}`,
      data
    );
  },

  // 【站位参考库-类别】复制到Xcube库，Xcube库 ROI 移除
  folder_operator_folder({ dev_id, category_id, target_category_id, type, roi_index_code, roi_index_code_target }, data) {
    if (type === 'remove') {
      if ([-1, -2].includes(category_id)) {
        // 团队参考库、Xcube 参考库
        return axios.post(`${BASE}/folder/operate-folder?category_id=${category_id}&type=${type}&roi_index_code=${roi_index_code}`, data);
      }
      return axios.post(`${BASE}/folder/operate-folder?dev_id=${dev_id}&category_id=${category_id}&type=${type}&roi_index_code=${roi_index_code}`, data);
    }
    return axios.post(
      `${BASE}/folder/operate-folder?dev_id=${dev_id}&category_id=${category_id}&type=${type}&roi_index_code=${roi_index_code}&roi_index_code_target=${roi_index_code_target}`,
      data
    );
  },

  roi_enhance(data) {
    return axios.post(`${process.env.NODE_ENV === 'development' ? 'api/' : ''}enhance`, data);
  },

  // 获取水质展示
  get_sensor_data(data) {
    return axios.post(`${BASE}/sensor/get-sensor-data`, data);
  },

  // 获取站位信息
  setting_get_site_info(params) {
    return axios.get(`${BASE}/setting/get-site-info`, {
      params
    });
  },
  // 修改站位信息
  setting_set_site_info(data) {
    return axios.post(`${BASE}/setting/set-site-info`, data);
  },

  // 获取ipp信息
  setting_get_ipp_info(params) {
    return axios.get(`${BASE}/setting/get-ipp-info`, {
      params
    });
  },
  // 修改ipp信息
  setting_set_ipp_info(data) {
    return axios.post(`${BASE}/setting/set-ipp-info`, data);
  },

  // 获取水质多参信息
  sensor_get_configuration(params) {
    return axios.get(`${BASE}/sensor/get-configuration`, {
      params
    });
  },
  // 修改水质多参信息
  sensor_update_configuration(data) {
    return axios.post(`${BASE}/sensor/update-configuration`, data);
  },

  // 修改水质多参信息
  sensor_trigger_update_config_now(data) {
    return axios.post(`${BASE}/sensor/trigger-update-config-now`, data);
  },

  // 折线图和柱状图融合
  views_get_chart_data(data) {
    return axios.post(`${BASE}/views/get-chart-data`, data);
  },

  // 获取水质多参参数
  get_sensor_params(params) {
    return axios.get(`${BASE}/sensor/get-sensor-params`, {
      params
    });
  },

  // 设置水质多参参数
  set_sensor_params(data) {
    return axios.post(`${BASE}/sensor/set-sensor-params`, data);
  },

  // 获取站位列表
  setting_site_list(params) {
    return axios.get(`${BASE}/setting/site-list`, {
      params
    });
  },

  // 查询协议签署信息
  protocol_sign_status(data) {
    return axios.post(`${BASE}/protocol/sign-status`, data);
  },

  // 同意协议签署
  protocol_agree(data) {
    return axios.post(`${BASE}/protocol/agree`, data);
  },

  // 重置协议签署
  protocol_reset_user_protocol(data) {
    return axios.post(`${BASE}/protocol/reset-user-protocol`, data);
  }
};
export default index;
